<template>
  <div>
    <social-sharing
      :url="url"
      media="https://swap.kulap.io/static/img/KULAP-banner.png"
      inline-template
    >
      <div class="dp-flex">
        <network network="facebook">
          <slot name="facebook">
            <img src="/static/svg/share-facebook.svg">
          </slot>
        </network>
        <network network="twitter">
          <slot name="twitter">
            <img src="/static/svg/share-twitter.svg">
          </slot>
        </network>
        <network network="linkedin">
          <slot name="linkedin">
            <img src="/static/svg/share-linkedin.svg">
          </slot>
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: 'ShareToSocials',
  props: {
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dp-flex {
  display: flex;
  width: 50%;
  justify-content: space-between;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  .dp-flex {
    width: 100%;
    margin: 0 auto;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareToSocials.vue